import { render, staticRenderFns } from "./dsar-dashboard.vue?vue&type=template&id=2fe973e4&"
import script from "./dsar-dashboard.vue?vue&type=script&lang=js&"
export * from "./dsar-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports